import { useState, type JSX } from 'react';
import ImageViewerPreview from './ImageViewerPreview';
import ImageViewerHero from './ImageViewerHero';
import ImageViewerZoomModal from './ImageViewerZoomModal';

interface IImage {
  src: string;
  alt?: string | null;
}

interface ImageViewerProps {
  images: IImage[];
  children?: React.ReactNode;
  hasZoom?: boolean;
  disabledMessage?: string;
  UNSAFE_className?: string;
}

const ImageViewer = ({
  children,
  images,
  hasZoom = false,
  disabledMessage,
  UNSAFE_className = '',
}: ImageViewerProps): JSX.Element | null => {
  const [selectedSlide, setSelectedSlide] = useState<number>(0);
  const [isZoomModalOpen, setIsZoomModalOpen] = useState<boolean>(false);
  const [zoomModalInitialIndex, setZoomModalInitialIndex] = useState<number>(0);

  if (!images || images.length < 1) return null;

  return (
    <section className={`image-viewer tw-flex ${UNSAFE_className}`}>
      <ImageViewerPreview
        images={images}
        selectedSlide={selectedSlide}
        onPreviewClick={(index) => {
          setSelectedSlide(index);
        }}
      />
      <ImageViewerHero
        images={images}
        selectedSlide={selectedSlide}
        onSlideChange={(index) => {
          setSelectedSlide(index);
        }}
        disabledMessage={disabledMessage}
        hasZoom={hasZoom}
        onZoom={(index) => {
          if (!hasZoom) return;

          setIsZoomModalOpen(true);
          setZoomModalInitialIndex(index);
        }}
      >
        {children}
      </ImageViewerHero>
      <ImageViewerZoomModal
        onSlideChange={(index) => {
          setSelectedSlide(index);
        }}
        images={images}
        isOpen={isZoomModalOpen}
        initialIndex={zoomModalInitialIndex}
        onClose={() => {
          setIsZoomModalOpen(false);
        }}
      />
    </section>
  );
};

export default ImageViewer;
